import { useState, useEffect } from 'react';

export const TAILWIND_SM_BREAKPOINT = 640;

export function useIsMobile(breakpoint = TAILWIND_SM_BREAKPOINT) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < breakpoint);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, [breakpoint]);

  return isMobile;
}
